export const ADD_PART = 'ADD_PART'
export const CLEAR_CART = 'CLEAR_CART'
export const FETCH_PARTS = 'FETCH_PARTS'

export const CREATE_CART = 'CREATE_CART'
export const UPDATE_CART = 'UPDATE_CART'
export const DELETE_CART = 'DELETE_CART'
export const FETCH_CART = 'FETCH_CART'
export const FETCH_CART_PRODUCTS = 'FETCH_CART_PRODUCTS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY'
